/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import L from "./Lang";
import Globals from "../shared/Globals";
import Icon from "./Icon";

class ProductModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    render() {
        if (!this.props.currentProduct) return;
        return <>
            <Modal show={this.props.currentProduct} onHide={this.props.onHide} size="xl">
                <Modal.Header>
                    <Modal.Title>
                        <L>{this.props.currentProduct.productName}</L>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-4">
                            <img src={Globals.getStorageURL(this.props.currentProduct.imageIdent)} alt="" className="img-fluid" />
                        </div>
                        <div className="col-md-4">
                            <p>{this.props.currentProduct.description}</p>
                        </div>
                        <div className="col-md-4">
                            <p>{this.props.currentProduct.specs}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary btn-lg" onClick={this.props.onHide}><Icon icon="faClose" /> <L>Close</L></button>
                </Modal.Footer>
            </Modal>
        </>;
    }
}

export default withParamsAndNavigate(ProductModal);